<template lang="html">
    <div class="centerx" style="min-width: 800px;">
    	<vs-popup :title="'Contrat N°' + contractId + ' ' + societyName"  :active.sync="isPopupActive">
      		<div class="container-fluid">
				<vx-card class="mb-1">
					<div class="vx-row">
						<div class="vx-col">
							<h3>
								Filtres :
							</h3>
						</div>
						<div class="vx-col px-1 mb-2">
							<vs-input class="inputx" placeholder="Lien ou landing page" v-model="linkNameFilter" @input="linkFilter()"/>
						</div>
						<div class="vx-col px-1 mb-2">
							<vs-select
								autocomplete
								v-model="typeFilter"
								class="w-full select-large"
								placeholder="Type Lien"
								@change="linkFilter()"
							>
								<vs-select-item
									value=""
									text="Type Lien"
									class="w-full"
								/>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in netlink_types"
									class="w-full"
								/>
							</vs-select>
						</div>
						<div class="vx-col px-1 mb-2">
							<vs-select
								autocomplete
								v-model="statusFilter"
								class="w-full select-large"
								placeholder="Statut"
								@change="linkFilter()"
								multiple
							>
								<vs-select-item
									:key="index"
									:value="item.value"
									:text="item.text"
									v-for="(item, index) in netlinkStatus"
									class="w-full"
								/>
							</vs-select>
						</div>
					</div>
					<div class="vx-row mt-2">
						<div class="vx-col">
							<strong>Nombre de résultats : {{ resultList.length }}</strong>
						</div>
					</div>
				</vx-card>
				<vs-table :data="resultList" class="mt-4" stripe :key="refreshKey">
					<template slot="thead">
						<vs-th sort-key="url_bought">Lien acheté</vs-th>
						<vs-th sort-key="landing_page">Landing page</vs-th>
						<vs-th sort-key="anchor_type">Type Ancre</vs-th>
						<vs-th sort-key="link_type">Type Lien</vs-th>
						<vs-th sort-key="creation_date" style="text-align: center;">Date Achat/Création</vs-th>
						<vs-th sort-key="status" style="display: flex; justify-content: center; margin-left: -5px;">Statut</vs-th>
						<vs-th></vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :key="index" v-for="(oneNetlink, index) in data">
							<vs-td :data="oneNetlink.url_bought"><a class="hvr-underline hvr-underline-out" :href="oneNetlink.url_bought" target="_blank">{{ oneNetlink.url_bought }}</a></vs-td>
							<vs-td :data="oneNetlink.landing_page">
								<a class="hvr-underline hvr-underline-out" :href="oneNetlink.landing_page" target="_blank">{{ oneNetlink.landing_page }}</a>
							</vs-td>

							<vs-td :data="oneNetlink.anchor_type">{{ getNetlinkAnchorType(oneNetlink.anchor_type) }}</vs-td>
							<vs-td :data="oneNetlink.link_type">{{ getNetlinkTypeName(oneNetlink.link_type) }}</vs-td>
							<vs-td :data="oneNetlink.creation_date"> {{ oneNetlink.creation_date ? getDateToFrenchFormat(oneNetlink.creation_date.substring(0,10)) : getDateToFrenchFormat(getPurchaseIdToPurchaseDate(oneNetlink.purchase_id)) }}</vs-td>

							<vs-td :data="oneNetlink.status" style="text-align: center;">
								<vs-chip
									style="width: 80px"
									:color="getNetlinkStatusColor(oneNetlink.status)"
									class="ml-2"
								>{{
									getNetlinkStatus(oneNetlink.status)
								}}</vs-chip>
							</vs-td>
							<vs-td>
								<vx-tooltip text="Modifier" position="top">
									<vs-button
										size="large"
										color="primary"
										type="flat"
										icon-pack="feather"
										icon="icon-edit-2"
										@click="updateNetlink(oneNetlink)"
									></vs-button>
								</vx-tooltip>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
				<div class="vx-col w-full mb-2">
					<vs-button style="float: right; margin-top: 20px;"
						icon-pack="feather" icon="icon-download-cloud"
						color="dark"
						@click="exportData(resultList)"
					>Exporter
					</vs-button>
				</div>
      		</div>
    	</vs-popup>
  	</div>
</template>

<script>
import Vue from "vue";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import "@/assets/css/toggle-switch.css";
import XLSX from "xlsx";

import store from "@/store/store";


export default {
	name: "NetlinkInfoPopup",
	props: {
		popupActive: Boolean,
		router: Object,
		apiUrl: String,
		contractId: Number,
		societyName: String
	},
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
	},
	created(){
		this.$http.get(this.apiUrl + 'society/all').then(res => {
			this.societies = res.data
		})
		this.getAllNetlinksType();
		this.getAllLinks();
	},
	watch: {
		list: async function(){
			this.linkFilter();
		}
	},

	data() {
		return {
			societies: [],
			list: [],
			resultList: [],
			isPopupActive: this.$props.popupActive,
			netlink_types: [],
			linkNameFilter: null,
			typeFilter: null,
			statusFilter: [1],
			netlinkStatus: [
				{text: "Actif", value: 0},
				{text: "En\u00a0attente", value: 1},
				{text: "Refusé", value: 2},
				{text: "Terminé", value: 3},
				{text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4},
				{text: "Annulé", value: 5}
			],
			refreshKey: 0
		};
	},

	methods: {
		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				data[i]["status"] = this.getNetlinkStatus(data[i]["status"]);
				data[i]["link_type"] = this.getNetlinkTypeName(data[i]["link_type"]);
				data[i]["anchor_type"] = this.getNetlinkAnchorType(data[i]["anchor_type"]);
				data[i]["society_id"] = this.research(data[i]["society_id"], this.societies, "id", "name");
				data[i]["creation_date"] = this.dateToFR(data[i]["creation_date"]);

				for(let x in data[i]){
					data[i][x] = String(data[i][x]).trim();
				}

				this.$delete(data[i], "dns_id");
				this.$delete(data[i], "provider_id");
				this.$delete(data[i], "renew_date");
				this.$delete(data[i], "id");
				this.$delete(data[i], "contract_id");
				this.$delete(data[i], "provider_name");
				this.$delete(data[i], "price");
				this.$delete(data[i], "domain_authority");
				this.$delete(data[i], "page_authority");
				this.$delete(data[i], "ref_domains");
				this.$delete(data[i], "external_links");
				this.$delete(data[i], "trust_flow");
				this.$delete(data[i], "citation_flow");
				this.$delete(data[i], "purchase_id");
				this.$delete(data[i], "recurring_purchase_id");
				this.$delete(data[i], "renew_duration");
			}

			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Netlink";

			let header = {
				header: [
					"society_id",
					"link_type",
					"anchor_type",
					"url_bought",
					"landing_page",
					"creation_date",
					"status"
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				society_id: "Société",
				link_type: "Type lien",
				anchor_type: "Type ancre",
				url_bought: "Lien Source",
				landing_page: "Landing Page",
				creation_date: "Date de création",
				status: "Statut"
			}];


			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Netlinks_export.xls");
		},
		async linkFilter(){
			let tmpList = [...this.list];
			if(this.typeFilter) tmpList = tmpList.filter(link => link.link_type == this.typeFilter);
			if(this.statusFilter.length > 0) tmpList = tmpList.filter(link => this.statusFilter.includes(link.status));
			if(this.linkNameFilter) tmpList = tmpList.filter(link => link.url_bought.indexOf(this.linkNameFilter) > -1 || link.landing_page.indexOf(this.linkNameFilter) > -1);

			this.resultList = tmpList;
			this.refreshKey++;
		},
		async getAllLinks(){
			await this.$http.get(this.apiUrl + "netlink/getFromContract/" + this.contractId)
				.then(res => {
					this.list = res.data;
				})
				.catch(err => {
					//console.log(err);
				}
				);
		},
		async getAllNetlinksType(){
			await this.$http.get("netlink/type/all")
				.then(res => {
					this.netlink_types = res.data;
				})
				.catch(err => {
					//console.log(err);
				}
				);
		},
		getNetlinkTypeName(netlinkTypeId){
			let foundNetlinkType = this.netlink_types.findIndex(row => row.id == netlinkTypeId);
			if(foundNetlinkType >= 0) return this.netlink_types[foundNetlinkType].name;
			else" ";
		},
		updateNetlink(netlink){
			this.$emit("modify-netlink", [netlink, this.societyName]);
		},
	}
};
</script>

<style scoped>
.table-client{
  padding: 0 20px 20px 20px;
}
.thead-client{
  white-space: nowrap;
}
.center {
  justify-content: center;
}

.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
</style>
